import React, {useState} from "react"
import { MDBContainer, MDBInput} from "mdb-react-ui-kit";
import {Typography, Alert} from "@mui/material";
import {useFormik} from "formik";
import * as Yup from 'yup';
import { useNavigate } from 'react-router-dom';
import {LocationState} from "./reset_password";
import {postForgot, ForgotBody} from "../../services/auth_request"
import LoadingButton from "../../componentes/LoadingButton";

interface ForgotPasswordInputProps {
    email: string;
}
const ForgotPassword:React.FC = () => {
     const navigate = useNavigate();
     const [alertM, setAlertM] = useState('')
     const {handleSubmit, handleChange, handleBlur, touched, errors, isValid, dirty, isSubmitting} = useFormik<ForgotPasswordInputProps>({
         initialValues:{
             email:'',
         },
         validationSchema: Yup.object({
             email: Yup.string()
                .email('Ingresa un correo electrónico válido')
                .required('Se debe ingresar un email'),
         }),
         onSubmit: async (values, {setSubmitting})=>{
             const body:ForgotBody = {
                 email: values.email
             }
             const response = await postForgot(body)
             if(response === 200){
                 navigate('/reset', { state: { datos: {email: values.email} } as LocationState });
             }else{
                 setAlertM('Error, el mail no está registrado')
             }
            setSubmitting(false)
         }
     })
    return <>
        {alertM !== '' && <Alert severity={'error'} color={'error'}>{alertM}</Alert>}
        <MDBContainer className="p-1 my-5 d-flex flex-column w-75" style={{ maxWidth: '500px' }}>
            <form onSubmit={handleSubmit}>
                <Typography fontWeight={700} variant='h5' textAlign={"center"}>Restablece tu contraseña</Typography>
                <Typography
                    variant='subtitle1'
                    textAlign={"center"}>
                    Por seguridad, enviaremos un código a tu email para verificar tu identidad.
                </Typography>
                <MDBInput
                    wrapperClass='mb-4'
                    label='Email address'
                    name='email'
                    id='email'
                    onBlur={handleBlur}
                    onChange={handleChange}
                    type='email'
                />
                {touched.email && errors.email ? (
                    <Alert severity={'info'} color={'warning'}>{errors.email}</Alert>
                  ) : null}
                <LoadingButton className="mb-4" variant={"contained"} color={"primary"} type='submit' disabled={!isValid || !dirty} loading={isSubmitting}>Restablece</LoadingButton>
            </form>
        </MDBContainer>
    </>
}
export default ForgotPassword